
import { Vue, Component } from 'vue-property-decorator'
import { ClueService } from '@/services'
import { ILevy } from '@/types/clue-types'

@Component({})
export default class AskCollectionList extends Vue  {
    private pageIndex = 1
    private pageTotal = 0
    private pageSize = 10
    private levyList = []
    private isLoading = false
    private statusOptions = [
        { value: '审核中', key: 1 },
        { value: '通过', key: 2 },
        { value: '不通过', key: 3 }
    ]

    private mounted() {
        this.initData()
    }

    private async initData() {
        const params = {
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        this.isLoading = true
        const result = await ClueService.getLevyList(params)
        this.isLoading = false
        if (result.status === 200) {
            this.levyList = result.data.list
            this.pageTotal = result.data.page_total
        }
    }

    private onLookDetail(id: number) {
        this.$router.push({
            name: 'LevySetting',
            params: { type: 'update' },
            query: { id: String(id) }
        })
    }

    private async onSwitchChange(status: boolean, id: number) {
        const params = {
            id,
            top: status
        }
        const result = await ClueService.updateLevy(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '切换成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: '切换失败, 请稍后再试'
        })
    }

    private async onStatusChange(status: number, id: number) {
        const params = { status: status, id }
        const result = await ClueService.updateLevy(params)
        if (result.status === 200) {
            this.levyList.map((levy: ILevy) => {
                if (levy.id === id) {
                    levy.status = status
                }
            })
            this.$message({
                type: 'success',
                message: '修改成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '修改失败',
            showClose: true
        })
    }

    private onPageChange(currPage: number) {
        this.pageIndex = currPage
        this.initData()
    }
}
